module.exports = __webpack_public_path__ + "img/graph-stats-ascend.7ce7f2a8.svg";